<template>
  <div class="inject-place-component d-flex flex-row flex-wrap">
    <pre class="d-none">lastInjectedAt: {{ lastInjectedAt }}</pre>
    <component
      v-for="({ componentDefinition, componentRefName }, index) in injectedComponents"
      :key="`${componentRefName}-${index}`"
      :is="componentDefinition"
    />
  </div>
</template>

<script>
/**
 * # InjectPlaceComponent: コンポーネント挿入 用 コンポーネント
 *
 * - 背景・役割: Vue App の 初期化後に 特定の コンポーネントを挿入して 追加するための コンポーネント
 *   - `$core.$componentStore` 経由で利用される
 */
export default {
  props: {
    injectPlaceKey: {
      type: String,
      required: true,
      validator: (value) => ['default-main-before', 'default-main-after'].includes(value),
    },
  },
  data() {
    return {
      // lastInjectedAt: 0,
    }
  },
  computed: {
    injectedComponents() {
      if (
        $core.$componentStore.injectedComponentsByKey[this.injectPlaceKey]?.lastInjectedAt
          ?.value < 0
      ) {
        return []
      }
      return (
        $core.$componentStore.injectedComponentsByKey[this.injectPlaceKey]?.components ||
        []
      )
    },
    lastInjectedAt() {
      return $core.$componentStore.injectedComponentsByKey[this.injectPlaceKey]
        ?.lastInjectedAt
    },
  },
}
</script>

<style scoped>
.inject-place-component {
  display: contents;
}
</style>
